import SecondaryMenu from '../components/SecondaryMenu';
import FaqComponent from '../components/FAQ';
import NumberFormat from 'react-number-format';
import React, { useEffect } from 'react';
import { ZendeskAPI } from 'react-zendesk';
import { NextSeo } from 'next-seo';
import { useRouter } from 'next/router';
import { config } from '_config';

function Faq() {
  const router = useRouter();
  useEffect(() => {
    let timeout;

    const handleRouteChangeComplete = () => {
      timeout = setTimeout(() => {
        window.scroll({ top: -100, left: 0, behavior: 'smooth' });
        clearTimeout(timeout);
      }, 100);
    };

    router.events.on('routeChangeComplete', handleRouteChangeComplete);

    return () => {
      clearTimeout(timeout);
      router.events.off('routeChangeComplete', handleRouteChangeComplete);
    };
  }, []);

  let phone = config.phone;
  const handleChat = () => {
    ZendeskAPI('webWidget', 'show');
    ZendeskAPI('webWidget', 'open');

    ZendeskAPI('webWidget:on', 'close', function () {
      ZendeskAPI('webWidget', 'hide');
    });
  };
  return (
    <div className="faq-page">
      <NextSeo title="FAQ" />
      <div className="top-banner">
        <div className="copy">
          <h1>Frequently Asked Questions</h1>
          <p>
            Still have questions?{' '}
            <a href={'tel:' + phone}>
              Call{' '}
              <NumberFormat
                value={phone}
                displayType={'text'}
                format="# (###)### - ####"
              />
            </a>{' '}
            or{' '}
            <span
              style={{ color: '#F37217', cursor: 'pointer' }}
              onClick={handleChat}
            >
              LIVE CHAT
            </span>{' '}
            with us for real-time support.
          </p>
        </div>
      </div>

      <SecondaryMenu />

      <div className="sides-wrapper">
        <div className="left-side">
          <FaqComponent leftSide={false} />
        </div>
        <div className="right-side">
          <div className="download-free">
            <h4>
              Download Our FREE
              <br />
              Trademark
              <br />
              Registration Guide
            </h4>
            <img
              src={`${config.basePath}/download-free.svg`}
              alt=""
              layout="fill"
            />
            <label>Full name</label>
            <input type="text" />
            <label>email</label>
            <input type="text" />
            <label>Phone number*</label>
            <input type="text" />
            <label>your trademark</label>
            <input type="text" />
            <a className="orange-btn" href="#">
              Download Guide
            </a>
            <p>
              * By entering your telephone number and clicking "Continue," you
              agree to let us follow up with you at this phone number regarding
              this and other services.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Faq;
